import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import Layout from './components/organisms/Layout'
import Home from './pages/Home'
import Principles from './pages/principles/Principles'
import ButtonsDetails from './pages/components/ButtonsDetails'
import Formularios from './pages/components/FormsDetails'
import Colors from './pages/fundations/Colors'
import Typo from './pages/fundations/Typo'
import Spacing from './pages/fundations/Spacing'
import Animations from './pages/fundations/Animations'
import IconSystem from './pages/fundations/IconSystem'
import Grid from './pages/components/Grid'
import HeaderDetails from './pages/components/HeaderDetails'
import FooterDetails from './pages/components/FooterDetails'
import AsteroidCardDetails from './pages/components/AsteroidCardDetails'
import FormBirthdayDetails from './pages/components/FormBirthdayDetails'
import HazardousCardDetails from './pages/components/HazardousCardDetails'
import PlayerDataDetails from './pages/components/PlayerDataDetails'
import RowGraphDataDetails from './pages/components/RowGraphDataDetails'
import OrderDropdownDetails from './pages/components/OrderDropdownDetails'
import ComparativeContainerDetails from './pages/components/ComparativeContainerDetails'
import ModalSuscribeDetails from './pages/components/ModalSuscribeDetails'
import ModalBirthdayDetails from './pages/components/ModalBirthdayDetails'

const App = () =>  (
  <BrowserRouter
    basename="/design-system"
  >
  <Layout>
    <Switch>
      <Route exact path="/" component={ Home } />
      <Route exact path="/principles" component={ Principles } />
      <Route exact path="/colors" component={ Colors } />
      <Route exact path="/typography" component={ Typo } />
      <Route exact path="/spacing" component={ Spacing } />
      <Route exact path="/animations" component={ Animations } />
      <Route exact path="/iconography" component={ IconSystem } />
      <Route exact path="/grid" component={ Grid } />
      <Route exact path="/header" component={ HeaderDetails } />
      <Route exact path="/footer" component={ FooterDetails } />
      <Route exact path="/buttons" component={ ButtonsDetails } />
      <Route exact path="/forms" component={ Formularios } />
      <Route exact path="/asteroid-card" component={ AsteroidCardDetails } />
      <Route exact path="/form-birthday" component={ FormBirthdayDetails } />
      <Route exact path="/hazardous-card" component={ HazardousCardDetails } />
      <Route exact path="/player-data" component={ PlayerDataDetails } />
      <Route exact path="/row-graph-data" component={ RowGraphDataDetails } />
      <Route exact path="/order-dropdown" component={ OrderDropdownDetails } />
      <Route exact path="/comparative-container" component={ ComparativeContainerDetails } />
      <Route exact path="/modal-suscribe" component={ ModalSuscribeDetails } />
      <Route exact path="/modal-birthday" component={ ModalBirthdayDetails } />
    </Switch>
  </Layout>
  </BrowserRouter>
)

export default App;
